import { DISMISS_NOTIFICATION, SHOW_NOTIFICATION_SUCCESS } from './types.js';

export const doDismissNotification = (ids) => ({
    type: DISMISS_NOTIFICATION,
    payload: { ids }
});

export const doShowNotification = (i18nKey) => ({
    type: SHOW_NOTIFICATION_SUCCESS,
    payload: { i18nKey }
});
